import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import type { MathOperation } from '../math-operation';
import { MathOperationRef } from './math-operation-ref';

@Injectable()
export class MathExpressionService {
  operations: MathOperationRef[] = [];

  restrictions = new Subject<{ maxWidth?: number; maxHeight?: number }>();

  fontFamily?: string;

  fontWeight?: number;

  color?: string;

  changes = new BehaviorSubject<{
    fontFamily?: string;
    fontWeight?: number;
    color?: string;
    flex?: number | null;
  }>({});

  readonly valueChanges = new Subject<void>();

  private _totalWidth: number = 0;

  public get totalWidth(): number {
    return this._totalWidth;
  }

  items: Map<
  MathOperation,
  {
    item: MathOperation;
    reserve: number;
  }
  > = new Map();

  private _availableSpace: { width: number; height: number };

  public get availableSpace(): { width: number; height: number } {
    return this._availableSpace;
  }

  public set availableSpace(value: { width: number; height: number }) {
    this._availableSpace = value;
    this._notify();
  }

  constructor() {}

  declareMathOperation(operation: MathOperation): MathOperationRef {
    const newOperation = new MathOperationRef(operation);
    this.operations.push(newOperation);
    return newOperation;
  }

  _notify() {
    if (!this._availableSpace?.width) return;
    const unit = this._availableSpace.width / this.totalWidth;
    this.items.forEach((item) => {
      item.item.setAvailableSpace({
        width: unit * item.reserve,
        height: this._availableSpace.height,
      });
    });
  }

  reserve(mathOperation: MathOperation, coef: number) {
    const operation = this.items.get(mathOperation);
    if (!operation) {
      this.items.set(mathOperation, {
        item: mathOperation,
        reserve: coef,
      });
    } else {
      this._totalWidth -= operation.reserve;
      operation.reserve = coef;
    }
    this._totalWidth += coef;
    this._notify();
  }

  remove(mathOperation: MathOperation) {
    const operation = this.items.get(mathOperation);
    if (operation) {
      this.items.delete(mathOperation);
      this._totalWidth -= operation.reserve;
    }
    this._notify();
  }
}
